import { store } from '@/store'
import Vue from 'vue'
import { Bridge } from './index'
import { EquatorialCoord } from '@hscmap/angle'

export abstract class StateLink {
  constructor(readonly b: Bridge) {
    const vue = new Vue()
    vue.$watch(() => this.what(), (what) => this.syncFromFrontend(what), { immediate: true, deep: true })
  }
  abstract what(): any
  abstract syncFromFrontend(what: any): void
  abstract restore(what: any): void
  protected sendSyncMessage(what: any) {
    this.b.port.postMessage({
      type: 'sync_from_frontend',
      args: what,
    })
  }
}

export function registerBasicLinks() {
  Bridge.registerStateLink('view', class extends StateLink {
    what() {
      return store.currentFrame.view
    }
    restore(view: typeof store.currentFrame.view) {
      store.currentFrame.view = view
      store.currentGlobe().requestRefresh()
    }
    syncFromFrontend(view: typeof store.currentFrame.view) {
      this.sendSyncMessage({ view })
    }
  })

  Bridge.registerStateLink('cameraMode', class extends StateLink {
    what() {
      return store.currentFrame.cameraMode
    }
    restore(cameraMode: typeof store.currentFrame.cameraMode) {
      store.currentFrame.cameraMode = cameraMode
      store.currentGlobe().requestRefresh()
    }
    syncFromFrontend(cameraMode: typeof store.currentFrame.cameraMode) {
      this.sendSyncMessage({ cameraMode })
    }
  })

  Bridge.registerStateLink('sspParams', class extends StateLink {
    what() {
      return store.currentFrame.modules.sspData.params
    }
    restore(sspParmas: typeof store.currentFrame.modules.sspData.params) {
      store.currentFrame.modules.sspData.params = sspParmas
      store.currentGlobe().requestRefresh()
    }
    syncFromFrontend(sspParams: typeof store.currentFrame.modules.sspData.params) {
      this.sendSyncMessage({ sspParams })
    }
  })

  Bridge.registerStateLink('rectSelection', class extends StateLink {
    what() {
      return store.modules.tool.rect
    }
    restore(rect: null | [{ a: number, d: number }, { a: number, d: number }]) {
      if (rect === null) {
        store.modules.tool.rect = null
      }
      else {
        const [c0, c1] = rect
        store.modules.tool.rect = { c0: json2eq(c0), c1: json2eq(c1) }
        store.currentGlobe().requestRefresh()
      }
    }
    syncFromFrontend(rect: typeof store.modules.tool.rect) {
      if (rect === null) {
        this.sendSyncMessage({ rectSelection: null })
      } else {
        this.sendSyncMessage({ rectSelection: [ea2json(rect.c0), ea2json(rect.c1)] })
      }
    }
  })

}

function ea2json(e: EquatorialCoord) {
  return { a: e.a.rad, d: e.d.rad }
}

function json2eq({ a, d }: { a: number, d: number }) {
  return EquatorialCoord.fromRad(a, d)
}
